module.exports = __webpack_public_path__ + "img/CircleMonkey-Monkey.1df30667.png";